var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/ActionBarHeader.tsx";
import React from 'react';
import { Divider, HStack, Text, VStack } from '@adc/parallax-component-library';
import { IconBack } from '@adc/parallax-icons';
import { usePartner } from 'Hooks';
import { IconButton } from 'Components/utility';
import i18n from 'Utilities/i18n';
const ActionBarHeader = () => {
  const {
    displayActionBarHeader,
    partner
  } = usePartner();
  if (!partner || !displayActionBarHeader) {
    return null;
  }
  return /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    padding: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    testID: "Partner.action-back-btn",
    marginRight: "$2",
    onPress: () => window.location.replace(partner.website),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconBack, {
    testID: "Partner.action-back-btn-icon",
    size: "XS",
    color: "$interactive.tertiary.enabled.onColor",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Text, {
    testID: "Partner.action-back-btn-text",
    fontSize: "$bodySmall.default",
    color: "$interactive.tertiary.enabled.onColor",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  }, i18n.t('Login.content.returnPartnerHeader.bodyText', {
    partnerName: partner.displayName
  }))), /*#__PURE__*/React.createElement(Divider, {
    marginTop: "$2",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }));
};
export { ActionBarHeader };